// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/medical-renewal-fit-unfit-and-issuance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/medical-renewal-fit-unfit-and-issuance/medical-renewal-fit-unfit-and-issuance.js';

mount([g0]);
